<template>
  <v-container>
    <v-card >
      <v-card-title>
        Add MSISDN Class
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
              v-model.number="msisdnClass.msisdn_class_id"
              label="MSISDN Class ID (for import matching)"
              type="number"
              :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
              v-model="msisdnClass.name"
              label="Name"
              :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
              v-model="msisdnClass.class_example"
              label="Class Example"
          ></v-text-field>
          <v-switch
              v-model="msisdnClass.active"
              :color="msisdnClass.active ? 'green' : 'red'"
              label="Active"
          ></v-switch>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="fetchAddNewMsisdnClass">Save</v-btn>
        <v-btn color="secondary" @click="resetForm">Reset</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { addNewMsisdnClass } from "@/composables/useGetMsisdnsAPIs";

export default {
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      msisdnClass:{
        msisdn_class_id: null,
        name:"",
        class_example:"",
        active:""
      },
      rules: {
        required: (value) => !!value || "This field is required",
      },
    };
  },
  methods: {
    async fetchAddNewMsisdnClass() {
      const result = await addNewMsisdnClass(this.token, this.msisdnClass);
      if (result.error) {
        alert("Error adding MSISDN Class: " + result.message);
      } else {
        alert("MSISDN Class saved successfully!");
        this.$emit("MsisdnClassSavedEvent", result);
      }
    },
    resetForm() {
      this.$emit('MsisdnClassResetEvent');
    },
  },
  created() {

  }
};
</script>
